module.exports = __webpack_public_path__ + "img/chinese_logo.ed1781d5.png";